(function () {
  "use strict";

  var scriptTag = document.currentScript;
  var ua = navigator.userAgent || navigator.vendor || window.opera;
  var isTikTok = ua.indexOf("TikTok") !== -1 || ua.indexOf("musical_ly") !== -1;
  if (!isTikTok) return;

  try {
    if (window.location.search.indexOf("utm_source=tiktok") === -1) {
      var joiner = window.location.search ? "&" : "?";
      var newUrl =
        window.location.pathname +
        window.location.search +
        joiner +
        "utm_source=tiktok&utm_medium=popup_bloqueo" +
        window.location.hash;
      window.history.replaceState(null, "", newUrl);
    }
  } catch (e) {
    console.log("Tracking error");
  }

  var copy = {
    intro: "To view this website correctly:",
    step1: 'Tap the three dots (<b>...</b>) in the top right corner.',
    step2: 'Select the <b>"Open in browser"</b> option.',
  };

  var style = document.createElement("style");
  style.textContent =
    "" +
    "#pw-tiktok-overlay {" +
    "position: fixed !important; top: 0 !important; left: 0 !important;" +
    "width: 100% !important; height: 100% !important;" +
    "background: rgba(10, 10, 10, 0.98) !important;" +
    "z-index: 9999999 !important; color: white !important;" +
    'font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif !important;' +
    "padding: 20px !important; box-sizing: border-box !important; display: block !important;" +
    "}" +
    "@keyframes pwOverlayGlow {" +
    "0%, 100% { filter: drop-shadow(0 0 2px rgba(231, 182, 109, 0.35)); opacity: 0.55; }" +
    "50% { filter: drop-shadow(0 0 15px rgba(231, 182, 109, 1)) drop-shadow(0 0 30px rgba(231, 182, 109, 0.8)); opacity: 1; }" +
    "}" +
    "#pw-tiktok-overlay .pw-overlay-logo {" +
    "display: block !important; width: 150px !important; height: auto !important;" +
    "margin: 0 auto 18px auto !important;" +
    "}" +
    "#pw-tiktok-overlay .pw-overlay-arrow {" +
    "position: absolute !important; top: 20px !important; right: 5px !important;" +
    "width: 150px !important; height: 150px !important; color: #E7B66D !important;" +
    "transform: rotate(25deg) !important; transform-origin: center !important;" +
    "animation: pwOverlayGlow 2s infinite ease-in-out !important;" +
    "}" +
    "#pw-tiktok-overlay .pw-overlay-instructions {" +
    "max-width: 400px !important; margin: 170px auto 0 auto !important;" +
    "text-align: left !important; font-size: 16px !important; line-height: 1.6 !important;" +
    "}" +
    "#pw-tiktok-overlay .pw-overlay-instructions p {" +
    "font-size: 19px !important; font-weight: 600 !important; margin-bottom: 25px !important;" +
    "text-align: center !important; color: #ffffff !important;" +
    "}" +
    "#pw-tiktok-overlay .pw-overlay-instructions ol { padding-left: 20px !important; }" +
    "#pw-tiktok-overlay .pw-overlay-instructions li {" +
    "margin-bottom: 18px !important; color: #e0e0e0 !important; font-size: 16px !important;" +
    "}";
  document.head.appendChild(style);

  function mount() {
    var logoUrl = scriptTag && scriptTag.dataset ? scriptTag.dataset.logo || "" : "";

    var overlay = document.createElement("div");
    overlay.id = "pw-tiktok-overlay";
    overlay.innerHTML =
      "" +
      (logoUrl ? '<img class="pw-overlay-logo" src="' + logoUrl + '" alt="Pawnelo">' : "") +
      '<svg class="pw-overlay-arrow" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">' +
      '<line x1="12" y1="22" x2="12" y2="3"></line>' +
      '<polyline points="5 10 12 3 19 10"></polyline>' +
      "</svg>" +
      '<div class="pw-overlay-instructions">' +
      "<p>" +
      copy.intro +
      "</p>" +
      "<ol>" +
      "<li>" +
      copy.step1 +
      "</li>" +
      "<li>" +
      copy.step2 +
      "</li>" +
      "</ol>" +
      "</div>";
    document.body.insertBefore(overlay, document.body.firstChild);
  }

  if (document.body) {
    mount();
  } else {
    document.addEventListener("DOMContentLoaded", mount);
  }
})();
